import React from 'react';
import { createRoot } from 'react-dom/client';
import { MESSAGING_ROOT_ID } from '../../constants';
import App from 'rearchitecture/app/App';
import { initBrowserStore } from '../../browser-store';
import { getCookie } from '@indeed/storage-consent-management';
import getTextClient from '../../i18n/getTextClient';

const getPageConfig = () => {
    const msgsClientOptions = window.__initialState.pageInitData.msgsClientOptions;
    const deviceMetaData = window.__initialState.pageConfigData.deviceMetaData;
    return {
        env: window.__initialState.pageConfigData.stagingEnv,
        csrfToken: getCookie('CSRF') ?? undefined,
        baseUrl: msgsClientOptions?.BASE_URL,
        pageLoadTk: msgsClientOptions?.PAGELOAD_TK,
        clientApp: msgsClientOptions?.CLIENT_APP,
        country: msgsClientOptions?.LOCALE_COUNTRY,
        lang: msgsClientOptions?.LOCALE_LANGUAGE,
        userAgent: {
            isMobile: deviceMetaData?.isUserAgentMobile ?? false,
            isNativeApp: deviceMetaData?.isNativeApp ?? false,
        },
    };
};

// Note: Pageload logging moved to server-side (IndexController.ts) for stability.
// Server-side logging is more reliable as it doesn't depend on client JavaScript execution.

// Initialize the browser store
if (window.__initialState) {
    try {
        initBrowserStore(
            window.__initialState.pageConfigData,
            window.__initialState.pageInitData,
            {}
        );
    } catch (error) {
        console.error('Failed to initialize browser store:', error);
    }
}

// Initialize the webapp-owned client localization path before rendering. The generated i18n
// bundle is unshifted ahead of the app bundle (see PageMetaDataProvider), so this global is
// already populated by the time this entry point runs. Falling back to an empty catalog keeps
// English rendering rather than throwing if that bundle is ever unavailable.
getTextClient.initialize(window['indeed.i18n.localeData'] ?? { '': {} });
delete window['indeed.i18n.localeData'];

const indexPageJsx = <App pageConfig={getPageConfig()} />;

const rootElement = document.getElementById(MESSAGING_ROOT_ID);
if (!rootElement) {
    throw new Error(`Could not find element with id ${MESSAGING_ROOT_ID}`);
}
createRoot(rootElement).render(indexPageJsx);
